import OTestPushSelected from './index.vue';

OTestPushSelected.install = app => {
  app.component(OTestPushSelected.name, OTestPushSelected);
};

export default OTestPushSelected;
